import { useEffect, useRef, useState } from 'react';

export const PHASES = {
    CLOSED: 'closed',
    OPEN: 'open',
    CLOSING: 'closing',
};

export const DEFAULT_ANIMATION_DURATION_MS = 300;

const useCloseAnimation = ({ isVisible, onClose, durationMs = DEFAULT_ANIMATION_DURATION_MS }) => {
    const [phase, setPhase] = useState(isVisible ? PHASES.OPEN : PHASES.CLOSED);
    const onCloseRef = useRef(onClose);
    const phaseRef = useRef(phase);

    useEffect(() => {
        onCloseRef.current = onClose;
    });

    useEffect(() => {
        phaseRef.current = phase;
    });

    useEffect(() => {
        if (isVisible) {
            setPhase(PHASES.OPEN);
            return undefined;
        }

        if (phaseRef.current === PHASES.CLOSED) {
            return undefined;
        }

        setPhase(PHASES.CLOSING);
        const timer = setTimeout(() => {
            setPhase(PHASES.CLOSED);
            if (onCloseRef.current) {
                onCloseRef.current();
            }
        }, durationMs);

        return () => {
            clearTimeout(timer);
        };
    }, [isVisible, durationMs]);

    return {
        phase,
        isOpen: phase === PHASES.OPEN,
        isClosing: phase === PHASES.CLOSING,
        isClosed: phase === PHASES.CLOSED,
    };
};

export default useCloseAnimation;
